import { render, staticRenderFns } from "./AddFacilityUser.vue?vue&type=template&id=30221246&scoped=true"
import script from "./AddFacilityUser.vue?vue&type=script&lang=js"
export * from "./AddFacilityUser.vue?vue&type=script&lang=js"
import style0 from "./AddFacilityUser.vue?vue&type=style&index=0&id=30221246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30221246",
  null
  
)

export default component.exports